import styled, { DefaultTheme } from "styled-components";
import { rgba } from "polished";

import { AlertKind } from "./index";

// Color mappings for each alert kind
const alertColors = {
  warning: {
    bg: (theme: DefaultTheme) => rgba(theme.color.palette.sunsetOrange, 0.12),
    border: (theme: DefaultTheme) =>
      rgba(theme.color.palette.sunsetOrange, 0.3),
    icon: (theme: DefaultTheme) => theme.color.palette.sunsetOrange,
  },
  error: {
    bg: (theme: DefaultTheme) => rgba(theme.color.palette.scarletRed, 0.12),
    border: (theme: DefaultTheme) => rgba(theme.color.palette.scarletRed, 0.3),
    icon: (theme: DefaultTheme) => theme.color.palette.scarletRed,
  },
  info: {
    bg: (theme: DefaultTheme) => rgba(theme.color.palette.cornflowerBlue, 0.12),
    border: (theme: DefaultTheme) =>
      rgba(theme.color.palette.cornflowerBlue, 0.3),
    icon: (theme: DefaultTheme) => theme.color.palette.cornflowerBlue,
  },
  success: {
    bg: (theme: DefaultTheme) => rgba(theme.color.palette.kellyGreen, 0.1),
    border: (theme: DefaultTheme) => rgba(theme.color.palette.kellyGreen, 0.25),
    icon: (theme: DefaultTheme) => theme.color.palette.kellyGreen,
  },
  muted: {
    bg: (theme: DefaultTheme) => rgba(theme.color.palette.anchorGrey, 0.1),
    border: (theme: DefaultTheme) => rgba(theme.color.palette.anchorGrey, 0.25),
    icon: (theme: DefaultTheme) => theme.color.palette.anchorGrey,
  },
};

export const Alert = styled.div<{ $kind: AlertKind }>`
  border-radius: 8px;
  border: 1px solid ${(p) => alertColors[p.$kind].border(p.theme)};
  background-color: ${(p) => alertColors[p.$kind].bg(p.theme)};
  padding: 0.875rem 1rem;
  margin-bottom: 1rem;
`;

export const AlertContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
`;

export const AlertIcon = styled.div<{ $kind: AlertKind }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  line-height: 1;
  color: ${(p) => alertColors[p.$kind].icon(p.theme)};
`;

export const AlertBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const AlertTitle = styled.div`
  font-weight: 600;
  font-size: 1rem;
  color: ${(p) => p.theme.text.default};
  line-height: 1.4;
`;

export const AlertText = styled.div`
  font-size: 0.875rem;
  color: ${(p) => p.theme.text.default};
  line-height: 1.5;

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
